import React, { useContext } from 'react';
import { Typography, Button } from '@material-ui/core';
import styled from 'styled-components';
import { DialogBox } from '@mummssoftware/common-ui';
import { VisitLogContext } from '../../Context/VisitLogContext';
import { SET_DATE_ERROR } from '../../Context/constants';
import defaults from '../../../translations/en.json';

export const DateWarningButtonsDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: 20px;
  margin: 1rem;
`;

type DateWarningDialogProps = {
  onRecord: () => void;
};

export const DateWarningDialog = ({ onRecord }: DateWarningDialogProps) => {
  const { dateError, dispatch } = useContext(VisitLogContext);
  const onCancel = () => {
    dispatch({
      type: SET_DATE_ERROR,
      payload: false,
    });
  };

  const onProceed = () => {
    dispatch({
      type: SET_DATE_ERROR,
      payload: false,
    });
    onRecord();
  };

  return (
    <DialogBox
      title={defaults.dateWarning}
      handleClick={() => null}
      open={dateError}
      noIcon
      BackdropProps={{ invisible: true }}
    >
      <>
        <Typography>{defaults.errorDate}</Typography>
        <DateWarningButtonsDiv>
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={onProceed}
          >
            {defaults.proceed}
          </Button>
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={onCancel}
          >
            {defaults.cancel}
          </Button>
        </DateWarningButtonsDiv>
      </>
    </DialogBox>
  );
};
